'use client';

import { c as _c } from "react/compiler-runtime";
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { getBotCookies } from './getBotCookies';
export function DataDogBotData() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  const {
    isBot,
    isVerifiedBot,
    botScore
  } = getBotCookies();
  datadogRum.startSessionReplayRecording();
  datadogRum.setUserProperty("is_bot", isBot);
  datadogRum.setUserProperty("is_verified_bot", isVerifiedBot);
  datadogRum.setUserProperty("bot_score", botScore);
}